import { useCallback, useRef } from "react";
import type { Map as MapboxMap } from "mapbox-gl";

const PIN_IMAGES: { name: string; url: string }[] = [
  { name: "approved-marker", url: "/images/pins/approved-marker.svg" },
  { name: "submitted-marker", url: "/images/pins/submitted-marker.svg" },
];

export const useMapboxImages = () => {
  const imageCache = useRef(new Map<string, HTMLImageElement>());

  const preloadImage = (url: string): Promise<HTMLImageElement> => {
    const cache = imageCache.current;
    const existing = cache.get(url);
    if (existing) {
      return Promise.resolve(existing);
    }
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        cache.set(url, img);
        resolve(img);
      };
      img.onerror = reject;
      img.src = url;
    });
  };

  const preloadImages = useCallback(async (map: MapboxMap | null) => {
    if (!map) return;

    await Promise.all(
      PIN_IMAGES.map(async ({ name, url }) => {
        try {
          const image = await preloadImage(url);
          if (!map.hasImage(name)) {
            map.addImage(name, image);
          }
        } catch (error) {
          console.error(`Failed to load image '${name}':`, error);
        }
      })
    );
  }, []);

  return { preloadImages };
};
